import BookMeeting from './BookMeeting';

export default BookMeeting;


// WEBPACK FOOTER //
// ./src/partials/modules/BookMeeting/index.js